import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

const TaxPayerInformation = ({ data }) => {
  return (
    <>
      <div className="row p-3">
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Registry Number
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'registry_number') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Number of Copies
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {_.get(data, 'number_of_copies') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              What to Print
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'what_to_print') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-12">
          <hr className="cit-hr" />
        </div>
        <div className="col-12 py-3">
          <div className="cit-label font-weight-bold text-success">
            DOCUMENT OWNER&apos;s PERSONAL INFORMATION
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              First Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'first_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Middle Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'middle_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Last Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'last_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Extension Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'extension_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Date of Death
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {moment(_.get(data, 'death_date')).format('YYYY-MM-DD') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">Sex</label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'gender') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Name of Hospital
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'hospital_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        {_.get(data, 'hospital_name') === 'OTHER' && (
          <div className="col-6 ">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label">
                Name of Hospital Other
              </label>
              <span className="cit-label font-weight-bold">:</span>
              <span className="cit-label font-weight-bold">
                {(_.get(data, 'hospital_other') || '--').toUpperCase()}
              </span>
            </div>
          </div>
        )}
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Place of Death
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'place_of_death_municipality_name') || '--'
              ).toUpperCase()}{' '}
              {(
                _.get(data, 'place_of_death_province_name') || '--'
              ).toUpperCase()}{' '}
              {(
                _.get(data, 'place_of_death_region_name') || '--'
              ).toUpperCase()}{' '}
            </span>
          </div>
        </div>
        {/* <div className="col-12">
          <hr className="cit-hr" />
        </div>
        <div className='col-12 py-3'>
          <div className="cit-label font-weight-bold text-success">
            DOCUMENT OWNER MOTHER&apos;s NAME
          </div>
        </div>
        <div className='col-6 '>
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Last Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'mothers_last_name') || '--'
              ).toUpperCase()}
            </span>
          </div>
        </div>
        <div className='col-6 '>
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Middle Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'mothers_middle_name') || '--'
              ).toUpperCase()}
            </span>
          </div>
        </div>
        <div className='col-6 '>
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              First Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'mothers_first_name') || '--'
              ).toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-12">
          <hr className="cit-hr" />
        </div>
        <div className='col-12 py-3'>
          <div className="cit-label font-weight-bold text-success">
            DOCUMENT OWNER FATHER&apos;s NAME
          </div>
        </div>
        <div className='col-6 '>
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Last Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'fathers_last_name') || '--'
              ).toUpperCase()}
            </span>
          </div>
        </div>
        <div className='col-6 '>
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Middle Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'fathers_middle_name') || '--'
              ).toUpperCase()}
            </span>
          </div>
        </div>
        <div className='col-6 '>
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              First Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(
                _.get(data, 'fathers_first_name') || '--'
              ).toUpperCase()}
            </span>
          </div>
        </div> */}
        <div className="col-12">
          <hr className="cit-hr" />
        </div>
        <div className="col-12 py-3">
          <div className="cit-label font-weight-bold text-success">
            REQUESTOR&apos;s INFORMATION
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              First Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'requestors_first_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Middle Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'requestors_middle_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Last Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'requestors_last_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Extension Name
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'requestors_extension_name') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Relationship to the Owner
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'relationship_to_the_owner') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Mailing Address
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {_.get(data, 'street') || '--'}{' '}
              {_.get(data, 'barangay_name') || '--'}{' '}
              {_.get(data, 'municipality_name') || '--'}{' '}
              {_.get(data, 'province_name') || '--'}{' '}
              {_.get(data, 'region_name') || '--'}{' '}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Zip Code
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'mailing_zip_code') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Tax Identification Number (TIN)
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'tin_number') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Telephone No.
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'telephone_number') || '--').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="col-6 ">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Mobile Number
            </label>
            <span className="cit-label font-weight-bold">:</span>
            <span className="cit-label font-weight-bold">
              {(_.get(data, 'mobile_number') || '--').toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

TaxPayerInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default TaxPayerInformation;
